import { combineReducers } from 'redux';
import patients from './patients'
const reducer = combineReducers({ patients })
export default reducer;